import { render, staticRenderFns } from "./EditRoles.vue?vue&type=template&id=ecc55ab6"
import script from "./EditRoles.vue?vue&type=script&lang=js"
export * from "./EditRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports